var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-text-editor"},[_c('quill-editor',{staticClass:"quill-editor",attrs:{"options":_vm.editorOptions},on:{"ready":_vm.onEditorReady},model:{value:(_vm.localContent),callback:function ($$v) {_vm.localContent=$$v},expression:"localContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }